import { Outlet, createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { requirePermission } from '@/app/guards';
import { zSearchText } from '@/shared/lib/search';

const misSearchSchema = z.object({ period: zSearchText(), asAt: zSearchText(), measure: zSearchText(), employment: zSearchText(), cohort: zSearchText(), product: zSearchText(), banks: zSearchText(), charts: zSearchText() });

export const Route = createFileRoute('/_app/mis')({
  validateSearch: misSearchSchema,
  staticData: { crumb: 'nav.mis', crumbTo: '/mis' },
  beforeLoad: ({ context }) => requirePermission(context.queryClient, 'mis.view', 'MIS'),
  component: Outlet,
});
